import axiosPrivateMl from "./axiosPrivateMl";

const createDuplicateAdset = async (payload) => {
  // POST to /duplicate_adset endpoint
  const response = await axiosPrivateMl.post("/duplicate_adset", payload);
  return response.data;
};

export default createDuplicateAdset;
